import { render, staticRenderFns } from "./CreatePasswordView.vue?vue&type=template&id=67038379"
import script from "./CreatePasswordView.vue?vue&type=script&lang=js"
export * from "./CreatePasswordView.vue?vue&type=script&lang=js"
import style0 from "./CreatePasswordView.vue?vue&type=style&index=0&id=67038379&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports